export const wuestenrotNextContactValidation = (
  contact: ContactFull,
  lastCallContact: Nilable<ContactRefType>,
  questionnaire: Nullable<CCTaskType>,
  _events: EventDetailWoContact[],
): [boolean, string] => {
  const status = contact.status?.name || "";

  if (["Beratung gewünscht", "kein Interesse"].includes(status) && !questionnaire) {
    return [false, "Bitte füllen Sie den Fragebogen aus!"];
  }

  if (["nicht erreichbar", "Gespräch verweigert", "falsche Kontaktdaten"].includes(status) && !questionnaire) {
    return [false, "Bitte geben Sie eine Zusammenfassung an!"];
  }

  if (contact.id === lastCallContact?.id) {
    return [true, ""];
  }

  const allowedStates = [
    "nicht erreichbar",
    "Gespräch verweigert",
    "falsche Kontaktdaten",
    "Beratung gewünscht",
    "kein Interesse",
  ];

  if (contact.status && allowedStates.includes(status)) {
    return [true, ""];
  }

  const toolTipText =
    "Bitte rufen Sie diesen Kontakt erst an oder setzen Sie ihn auf eine der folgenden Statusmöglichkeiten: „nicht erreichbar“, „Gespräch verweigert“, „falsche Kontaktdaten“";

  return [false, toolTipText];
};
